// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"133":"87fbec74","344":"9e2a44f8","492":"8dba15cb","587":"ead6dd5a","640":"c312801e","727":"b36c2155","771":"b2b404c2","828":"a09d3c38"}[chunkId] + ".chunk.js";
};